import React, { useContext, useEffect, useState } from 'react';
import { Flex } from '@chakra-ui/layout';
import { useParams } from 'react-router-dom';
import { SharedExperiencesProvider } from '../lib/sharedExperiencesProvider';
import SharedExperiencePageProvider from './lib/sharedExperiencePageProvider';
import SharedExperienceAside from './components/sharedExperienceAside';
import ExperiencesInSharedExperienceList from './components/experiencesInSharedExperienceList';
import SharedExperienceMembers from './components/sharedExperienceMembers';
import LoadingSharedExperience from './LoadingSharedExperience';
export default function SharedExperienceDetailPage() {
  const [loadingSharedExperience, setLoadingSharedExperience] = useState(true);
  const [sharedExperienceId, setSharedExperienceId] = useState(null);
  const [readyToGetId, setReadyToGetId] = useState(null);
  const params = useParams();
  useEffect(() => {
    if (readyToGetId && params.id !== sharedExperienceId) {
      setSharedExperienceId(parseInt(params.id));
      setReadyToGetId(false);
    }
  }, [readyToGetId]);
  useEffect(() => {
    if (params.id && params.id !== sharedExperienceId) {
      setReadyToGetId(true);
    }
  }, [params.id]);
  return (
    <>
      {sharedExperienceId && (
        <>
          {loadingSharedExperience && (
            <LoadingSharedExperience />
          )}
          <SharedExperiencesProvider 
            sharedExperienceId={sharedExperienceId}
            onInit={() => {
              setLoadingSharedExperience(false);
            }}
          >
            <SharedExperiencePageProvider>
              {!loadingSharedExperience && (
                <Flex
                  flex="1"
                  flexDirection="row"
                  alignItems="stretch"
                  overflow="auto"
                >
                  <SharedExperienceAside />
                  <Flex
                    flex="1"
                    flexDirection="column"
                    overflow="auto"
                  >
                    <Flex
                      px={3}
                      py={2}
                      bg="white"
                      borderBottom="1px solid"
                      borderColor="divider.grey"
                      justifyContent="flex-end"
                    >
                      <SharedExperienceMembers />
                    </Flex>
                    <Flex
                      flex="1"
                      overflow="auto"
                      flexDirection="column"
                    >
                      <ExperiencesInSharedExperienceList />
                    </Flex>
                  </Flex>
                </Flex>
              )}
            </SharedExperiencePageProvider>
          </SharedExperiencesProvider>
        </>
      )}
    </>
  );
} 